<template>
  <div class="newspanel" :class="newsPanelVisible ? 'newspanel-slide-in' : 'newspanel-slide-out'">
    <div class="newspanel-header">
      <font-awesome-icon icon="fa-solid fa-xmark" class="newspanel-close-icon" @click="setNewsPanelVisible(false)"/>
      <p class="newspanel-header-text">{{ $t("label.News") }}</p>
    </div>
    <div class="newspanel-content">
      <div
        v-if="newsItems.length === 0 && newsItemsReady"
        class="newspanel-notfound">
        <p>{{ $t("message.NoNewsItems") }}</p>
      </div>
      <div
        v-else-if="newsItemsReady"
        class="newspanel-items">
        <NewsItem
          v-for="newsItem in newsItems"
          :key="newsItem.id"
          :newsItemData="newsItem"
          :language="language" />
      </div>
      <div
        v-else
        class="newspanel-loading">
        <span class="glyphicons glyphicons-refresh spinning"></span>
        <p>{{ $t("other.loading") }}...</p>
      </div>
    </div>
  </div>
</template>

<script>
import cookie from 'vue-cookie'
import NewsItem from './newsItem'

export default {
  name: 'NewsPanel',
  components: {
    NewsItem
  },
  props: {
    newsPanelVisible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      language: cookie.get('language'),
      newsItemsReady: false
    }
  },
  created () {
    this.checkReadNewsItems()
  },
  computed: {
    newsItems () {
      return this.$store.getters.newsItems
    }
  },
  watch: {
    newsPanelVisible: {
      immediate: true,
      handler (visible) {
        if (visible) {
          this.loadNewsPanelItems()
        } else if (this.newsItems.length === 0) {
          this.newsItemsReady = false
        }
      }
    }
  },
  methods: {
    setNewsPanelVisible (value) {
      this.$emit('update:newsPanelVisible', value)
    },
    async loadNewsPanelItems () {
      if (this.newsItems.length > 0) {
        this.newsItemsReady = true
        return
      }

      this.newsItemsReady = false

      try {
        await this.$store.dispatch('loadNewsItems')
      } finally {
        this.newsItemsReady = true
      }
    },
    async checkReadNewsItems () {
      if (this.newsItems.length === 0) {
        await this.$store.dispatch('loadNewsItems')
      }
      this.$store.dispatch('getSettingByName', {
        settingName: 'LastNewsItemRead'
      }).then((response) => {
        if (!this.newsItems) return
        const dates = this.newsItems.map((newsItem) => new Date(newsItem.date))
        const lastReadNewsItemDate = new Date(parseInt(response.data.SettingValue, 10))
        this.$emit('update:unreadNewsItems', !lastReadNewsItemDate || isNaN(lastReadNewsItemDate) || Math.max(...dates) > lastReadNewsItemDate)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.newspanel {
  position: absolute;
  right: 0;
  width: 50vw;
  height: calc(100vh - 60px);
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  background-color: @white;
  box-shadow: 0px 24px 48px -12px rgba(16, 24, 40, 0.18);
  transition: transform 0.33s;

  .newspanel-header {
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 13px 32px 13px 21px;
    border-bottom: 1px solid @brownTerra200;

    .newspanel-header-text {
      font-weight: 600;
      font-size: 18px;
      line-height: 28px;
      margin: 0 30px 0 8px;
      color: @gray700;
    }

    .newspanel-close-icon {
      cursor: pointer;
      font-size: 18px;
      padding: 9px 11px;
      border-radius: 6px;
      margin: 0;
      line-height: 22px;
      color: #020202;
    }

    .newspanel-close-icon:hover {
      background-color: @hover-white-button;
    }
  }

  .newspanel-content {
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .newspanel-items {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .newspanel-loading {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 16px;

    .spinning {
      font-size: 48px;
      color: @primaryGreen;
      animation: spinning 1s linear infinite;
    }

    p {
      font-size: 20px;
      color: @gray700;
      margin: 0;
    }
  }

  .newspanel-notfound {
    width: 70%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    p {
      font-size: 18px;
      color: @gray700;
      margin: 0;
    }
  }
}

.newspanel.newspanel-slide-in {
  transform: translateX(0);
}

.newspanel.newspanel-slide-out {
  transform: translateX(~"max(350px, 50vw)");
}

@keyframes spinning {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
